import { Fallback } from '@radix-ui/react-avatar'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
  useEffect,
  useState,
} from 'react'
import { Skeleton } from '#src/components/core/Skeleton.tsx'

export const AvatarFallback = forwardRef<
  ElementRef<typeof Fallback>,
  ComponentPropsWithoutRef<typeof Fallback>
>(({ className, delayMs, children, ...props }, ref) => {
  const [didDelay, setDidDelay] = useState(false)
  const showSkeleton = delayMs !== undefined && !didDelay

  useEffect(() => {
    if (delayMs !== undefined) {
      const timeoutId = setTimeout(() => setDidDelay(true), delayMs)
      return () => clearTimeout(timeoutId)
    }
    return undefined // Appease TS7030 (Not all code paths return a value)
  }, [delayMs])

  return (
    <Fallback
      ref={ref}
      className={cn(
        'flex size-full items-center justify-center rounded-full bg-muted text-muted-foreground',
        className
      )}
      {...props}
    >
      {showSkeleton && <Skeleton className="size-full" />}
      {!showSkeleton && children}
    </Fallback>
  )
})
AvatarFallback.displayName = Fallback.displayName
